
     var idioma = $('html').attr('lang');
     
     if(idioma == "en"){
       $('.text_announcment > p').html('WE SHIP FROM LIMA');
       $('.site-footer div.grid__item.footer__item--1494292487693 > div > h2').html('JOIN OUR TRIBE');
     }else{
       $('.text_announcment > p').html('NOSOTROS ENVIAMOS DESDE LIMA');
       $('.site-footer div.grid__item.footer__item--1494292487693 > div > h2').html('ÚNETE A NUESTRA TRIBU');
     }





function cambiar_texto(elemento , texto){
  var labelElement = $(elemento);
labelElement.contents().filter(function() {
    return this.nodeType === 3; 
}).first().replaceWith(texto);

}

// cambiar_texto(elemento , texto);
cambiar_texto('#shopify-section-template--16741412897004__main label[for="ProductSelect-template--16741412897004__main-7671108501740-option-0"]' , 'PRINTS');

// cambiar_texto(elemento , texto);
cambiar_texto('#shopify-section-template--16741412897004__main label[for="ProductSelect-template--16741412897004__main-7671114793196-option-0"]' , 'PRINTS');

// cambiar_texto(elemento , texto);
cambiar_texto('#shopify-section-template--16741412897004__main label[for="ProductSelect-template--16741412897004__main-7671132160236-option-0"]' , 'PRINTS');

// cambiar_texto(elemento , texto);
cambiar_texto('#shopify-section-template--16741412897004__main label[for="ProductSelect-template--16741412897004__main-7671119315180-option-0"]' , 'PRINTS');

// cambiar_texto(elemento , texto);
cambiar_texto('#shopify-section-template--16741412897004__main label[for="ProductSelect-template--16741412897004__main-7671126851820-option-0"]' , 'PRINTS');

// cambiar_texto(elemento , texto);
cambiar_texto('#shopify-section-template--16741412897004__main label[for="ProductSelect-template--16741412897004__main-7671110992108-option-0"]' , 'PRINTS');

// cambiar_texto(elemento , texto);
cambiar_texto('#shopify-section-template--16741412897004__main label[for="ProductSelect-template--16741412897004__main-7671116529900-option-0"]' , 'PRINTS');